<template>
  <div class="enterprise">
    <router-view></router-view>
    <ContentView  v-if="isDetail==false">
      <template slot="operateLeft">
        <el-input class="enter-input" v-model="searchVal"  size="small" placeholder="请输入内容" @keyup.enter.native="search"></el-input>
        <el-button style="margin-left: 15px;" size="small" @click="addNotice">新建公告</el-button>
      </template>
      <template slot="operateRight"></template>
      <el-table slot="contentBox" :data="tableData"  border @row-click="onDetail" style="width: 100%">
        <el-table-column prop="title" width="160" label="标题"></el-table-column>
        <el-table-column prop="content" label="内容" ></el-table-column>
        <el-table-column prop="pushTime" label="发布时间" width="180"></el-table-column>
        <el-table-column prop="pushUser" label="发布账户" width="140"></el-table-column>
      </el-table>
    </ContentView>
    <el-dialog title="公告详情" :visible.sync="dialogFormVisible">
        <el-form :model="form">
            <el-form-item label="标题" >
                <el-input v-model="form.Title" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="内容" >
                <el-input  type="textarea"  v-model="form.Content" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="发布时间" >
                <el-input v-model="form.PushTime" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="发布帐户" >
                <el-input v-model="form.PushUser" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button style="color:#fff" type="primary" @click="onSave">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import ContentView from "@/components/ContentView";
import apiPub from '@/api/public'
export default {
  name: "enterprise",
  data() {
    return {
      tableData: [],
      searchVal:"",
       options:[],
       dialogFormVisible:false,
       form:{},
    input:"",
      win: false,
      value: "",
      timesRun: 0,
      isDetail:false
    };
  },
  components: {
    ContentView
  },
  watch:{
      $route(to,from){
        // console.log(to);
        // this.controlRouter()
        if (to.name != 'notice') {
          this.isDetail = true;
        } else {
          this.isDetail = false;
          this.search()
        }
    }
  },
  created() {
    this.search();
    this.controlRouter()
  },
  methods: {
    
    //---------------查询区域--------begin-----------
    controlRouter() {
      // console.log(this.$router.currentRoute)
       if (this.$router.currentRoute.name != 'notice') {
        this.isDetail = true;
      } else {
        this.isDetail = false;
      }
    },
    search(){
      this.getlist()
    },
    addNotice(){
      this.$router.push({
        path: "/notice/noticeForm",
        query: { }
      });
    },
    
    //---------------业务区域--------end-----------
    onSave(){
      
      var that=this;
      var obj = {
        "url": apiPub.AddNotice,
        "data":{
          "Content":this.form.Content,
          "Nstate":"0",
          "PushTime":this.form.PushTime,
          "PushUser":this.form.PushUser,
          "Title":this.form.Title
        }
      };
      $http.request(obj,false,function(res) {
        console.log(res)
        that.tableData=res.data;
      })
    },
    
    //---------------表格操作--------begin-----------
    getlist(){
      var that=this;
      var SearchText=this.searchVal||""
      var obj = {
        "url": apiPub.GetNoticeList,
        "data":{
          SearchText:SearchText
        }
      };
      $http.request(obj,false,function(res) {
        // console.log(res)
        that.tableData=res.data;
      })
    },
    onDetail(e){
       this.$router.push({path: '/notice/noticeForm', query: {id:e.id}});
       return;
    }
    /// -----------------------分页--begin-----------------------------
    /// -----------------------分页--end-------------------------------
  }
};
</script>
<style scoped>
.enterprise {
  /* padding: 20px; */
  background: #fff;
}
.org-logo {
  width: 40px;
  height: 40px;
}
.enter-input{
    width: 200px;

}
.enter-input+.enter-input{
    margin-left: 15px;
}
.el-form-item{
    margin-bottom: 10px;
}
</style>
